import { EMAIL_FOUND, EMAIL_NOT_FOUND, RESET_EMAIL_VERIFICATION } from '../constants/action_types';
import { checkEmail } from '../api/api';
import isEmpty from "lodash/isEmpty";
import { showFirstSignIn, showSignIn, showSignUp } from './signInModal';

const emailNotFound = () => ({
    type: EMAIL_NOT_FOUND
});

const resetEmailVerification = () => ({
    type: RESET_EMAIL_VERIFICATION
});

const submitEmailVerification = (data) => dispatch => {

    return checkEmail(data.email)
        .then(res => {
            if (!res.ok || !isEmpty(res.body.errors)) {
                return dispatch(emailNotFound());
            }
            if (res.body.password) {
                dispatch(showSignIn(data.email))
            }
            else if (!res.body.valid && !res.body.password) {
                dispatch(showFirstSignIn(data.email))
            }
            else {
                dispatch(showSignUp(data.email))
            }
        })
};

export {
    submitEmailVerification,
    resetEmailVerification
};
